<template>
  <div class="reqWrap">
    <div class="reqThanks u-containar-md">
      <p class="reqThanks_heading">申込みが完了しました。</p>
      <p>
        申込み内容は、マイページからご確認できます。当サイトからキャンセルできませんので、キャンセルしたい場合は病院に直接お問い合わせください。問い合わせ先はマイページからご確認いただけます。
      </p>
    </div>

    <GoalButtons type="contents">
      <Button
        v-if="prevPage"
        label="元のページに戻る"
        :href="prevPage"
        :handleClick="() => $router.push(prevPage)"
      />
      <Button
        label="トップページへ"
        primary
        href="/"
        :handleClick="() => $router.push('/')"
      />
    </GoalButtons>
  </div>
</template>

<script lang="ts">
import { SetupContext } from 'vue'
import GoalButtons from '@/components/block/GoalButtons.vue'
import Button from '@/components/elements/Button.vue'
import { useRouter } from 'vue-router'

export default {
  name: 'DocumentRequestThanks',

  components: {
    GoalButtons,
    Button
  },

  props: {
    state: {
      type: Object,
      require: true
    }
  },

  setup(props: any, context: SetupContext) {
    const router = useRouter()

    // 入力ページ経由じゃない場合は弾く
    if (!props.state.isLandingInput) {
      router.replace('/500')
    }

    // 申し込みフローの更新
    context.emit('update-flow', 3)

    // 確認ページに戻れないように
    context.emit('update-landing-state', false)

    const from = document.cookie
      .split('; ')
      .find((row) => row.startsWith('documentRequestFrom'))
    const prevPage = from ? from.split('=')[1] : ''
    if (from) {
      document.cookie = 'documentRequestFrom=; max-age=0; path=/'
    }

    return {
      prevPage
    }
  }
}
</script>

<style lang="scss">
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;
</style>
